import { call, put } from "redux-saga/effects";
import { instructorCourseApi } from "@services/api";
import { getMyCoursesActions } from "../slices";

function* getMyCoursesWorker({ payload }) {
  try {
    yield put(getMyCoursesActions.pending());
    const response = yield call(instructorCourseApi.getMyCourses, payload);
    yield put(getMyCoursesActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getMyCoursesActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { getMyCoursesWorker };
